import { BankOutlined, IdcardOutlined, SolutionOutlined, UsergroupAddOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Card, Col, Descriptions, Image, Row, Statistic } from "antd";
import { useNavigate } from "react-router";

import './Dashboard.less';

const Dashboard = ()=>{

    const navigate = useNavigate();

    return (
        <Row gutter={16} style={{width:'100%', height:'100%'}} className="dashboard">
            <Col span={8}>
                <Card title="项目信息">
                    <Descriptions column={1}>
                        <Descriptions.Item label="项目代码">
                            330881202206192001
                        </Descriptions.Item>
                        <Descriptions.Item label="项目名称">
                            浙江鸿正软件科技有限公司办公大楼建设
                        </Descriptions.Item>
                        <Descriptions.Item label="施工单位">
                            浙江鸿正软件科技有限公司
                        </Descriptions.Item>
                        <Descriptions.Item label="监理单位">
                            浙江鸿正软件科技有限公司
                        </Descriptions.Item>
                    </Descriptions>
                </Card>

                <Card title="常用功能" style={{marginTop:16}}>
                    <div style={{color: '#2791fe'}}>
                        <div 
                            className="frequencyButton"
                            onClick={()=>{
                                navigate("/hr/contractor");
                            }}
                        >
                            <div>
                                <BankOutlined style={{fontSize:24}} />
                            </div>
                            <div>参建单位</div>
                        </div>

                        <div 
                            className="frequencyButton"
                            onClick={()=>{
                                navigate("/hr/work-team");
                            }}
                        >
                            <div>
                                <UsergroupAddOutlined style={{fontSize:24}} />
                            </div>
                            <div>班组信息</div>
                        </div>

                        <div 
                            className="frequencyButton"
                            onClick={()=>{
                                navigate("/hr/employee");
                            }}
                        >
                            <div>
                                <IdcardOutlined style={{fontSize:24}} />
                            </div>
                            <div>工人信息</div>
                        </div>

                        <div 
                            className="frequencyButton"
                            onClick={()=>{
                                navigate("/hr/contract");
                            }}
                        >
                            <div>
                                <SolutionOutlined style={{fontSize:24}} />
                            </div>
                            <div>人事合同</div>
                        </div>

                        <div 
                            className="frequencyButton"
                            onClick={()=>{
                                navigate("/hr/attendance-machine");
                            }}
                        >
                            <div>
                                <VideoCameraOutlined style={{fontSize:24}} />
                            </div>
                            <div>考勤机</div>
                        </div>
                    </div>
                </Card>

                <Card title="实时考勤状况" style={{marginTop:16}}>
                    <div style={{textAlign:'center'}}>
                        <Image
                            style={{marginLeft:'auto', marginRight:'auto'}}
                            width={120}
                            height={160}
                            src="error"
                            fallback="data:image/png;base64,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"
                        />
                    </div>
                    <div style={{textAlign:'center', lineHeight:'28px', fontSize:14}}>
                        打卡时间：12:00:00(进)<br/>
                        班组：项目部<br/>
                        工种类型：项目经理<br/>
                    </div>
                </Card>
            </Col>

            <Col span={16}>
                <Card>
                    <Row gutter={16} >
                        <Col span={12}>
                            <Statistic 
                                title={<div style={{color:'#fff'}}>当前在场</div>}
                                value={100}
                                valueStyle={{ color: '#fff' }}
                                suffix="人"
                                style={{backgroundColor:'#54ade8', color:'#fff', padding:8}}
                            />
                        </Col>
                        <Col span={12}>
                            <Statistic 
                                title={<div style={{color:'#fff'}}>今日出勤</div>}
                                value={100}
                                valueStyle={{ color: '#fff' }}
                                suffix="人"
                                style={{backgroundColor:'#ff6c60', color:'#fff', padding:8}}
                            />
                        </Col>
                        <Col span={12}>
                            <Statistic 
                                title={<div style={{color:'#fff'}}>当前在职</div>}
                                value={100}
                                valueStyle={{ color: '#fff' }}
                                suffix="人"
                                style={{backgroundColor:'#4dccb3', color:'#fff', padding:8, marginTop:16}}
                            />
                        </Col>
                        <Col span={12}>
                            <Statistic 
                                title={<div style={{color:'#fff'}}>临时离场</div>}
                                value={100}
                                valueStyle={{ color: '#fff' }}
                                suffix="人"
                                style={{backgroundColor:'#6385a7', color:'#fff', padding:8, marginTop:16}}
                            />
                        </Col>
                    </Row>
                </Card>

                <Card title="班组出勤状况" style={{marginTop:16}}>
                    <div style={{height:280}}>

                    </div>
                </Card>

                <Card title="近7天考勤状况" style={{marginTop:16}}>
                    <div style={{height:280}}>

                    </div>
                </Card>
            </Col>
        </Row>
    );
}

export default Dashboard;